import { CoreHomeView } from '../../../../core/views';

import template from './index.jst';
import './index.styl';
import { Preloader } from "../../../../core/utils";

class HomeView extends CoreHomeView {
	get template() {
		return template;
	}

	get className() {
		return "home-page home-page-fantasy";
	}

	async fetchData() {
		Preloader.show();
		await this.options.news.fetch();

		this.model.set({ news: this.options.news.toJSON() });

		this.render()
		Preloader.hide()

	}
}

export default HomeView;